<template>
  <div class="Modal" v-if="flag">
    <div class="vio" :class="'specialStyle'+specialStyle">
       <div class="border">
          <div class="closeBtn" @click="close"></div>
        </div>
      <video controlslist="nodownload" class="video" controls="controls" autoplay :src="src"></video>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    flag: {
      value: {
        type: Boolean,
        default() {
          return false;
        }
      }
    },
    src: {
      value: {
        type: String,
        default() {
          return "";
        }
      }
    },
    specialStyle:{
       value: {
        type: Number,
        default() {
          return 0;
        }
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped>
.Modal {
  width: 100%;
  height: 100%;
  background-color: rgba(55, 55, 55, 0.6);
  z-index: 170;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  
  .vio {
    position: fixed;
      width: 686px;
      height: auto;
    border: 8px solid #fff;
    border-radius: 12px;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    box-sizing: border-box;
    background: #fff;
    .border {
      position: absolute;
      right: -8px;
      top: -56px;
      border: 2px solid #ffffff;
      border-radius: 50%;
      padding: 2px;
    }
    .closeBtn {
      background: url("../../assets/common/closeBtn.png");
      width: 24px;
      height: 24px;
      background-size: cover;
    }
    video {
      outline: none;
      width: 100%;
      height: 100%;
      border-radius: 12px;
   
    }
  }
  .specialStyle1{
   height: 392px !important;
  }
  .specialStyle2{
   height: 435px !important;
  }
}
</style>